{
  "app.title": "Welcome to {{app}}",
  "global.filters": "Filters",
  "global.enter.dashboard": "Enter dashboard",
  "global.return.manpage": "Return to the main page",
  "global.about": "About",
  "global.professionals": "Professionals",
  "global.therapist_treatments": "Therapist Treatments",
  "global.back": "Go Back",
  "global.me": "Myself",
  "global.others": "For family and friends",
  "global.addNewMember": "Add New Member",
  "global.loading": "Loading...",
  "global.retry": "Retry",
  "global.logout": "Log Out",
  "nav.home": "Home",
  "nav.page2": "Page 2",
  "nav.selectDoctor": "Find a Doctor",
  "profile.myProfile": "My Profile",
  "form.error.email": "Email address is incorrect.",
  "form.error.pattern": "Pattern is not matched.",
  "form.error.password.match": "Passwords are not matched.",
  "form.error.min": "The minimum character entered must be",
  "form.error.max": "The maximum value must be",
  "form.error.max.reach": "Maximum characters has been reached.",
  "form.select.emptyMessage": "No results found",
  "profile.signOut": "Sign Out",
  "shared.button.save": "Save",
  "shared.button.cancel": "Cancel",
  "signin.platformName": "Wira",
  "signin.title.base": "Login or Sign Up",
  "signin.title": "Sign in",
  "signin.tabs.email": "Email",
  "signin.tabs.phone": "Phone",
  "signin.label.email": "Email address",
  "signin.label.phone": "Phone number",
  "signin.submit": "Continue",
  "signin.subtitle": "Join us on the journey toward mental well-being.",
  "signin.guestPrompt": "Need an urgent appointment?",
  "signin.guestAction": "Book appointment without sign-in",
  "signin.email.massage": "Please enter your valid email address",
  "signin.phone.massage": "Your mobile number (e.g. 9121234567)",
  "signin.otp.title": "Enter the 6-digit code",
  "signin.otp.changeEmail": "Change email address",
  "signin.otp.changePhone": "Change phone number",
  "signin.validation.required": "This field is required.",
  "signin.validation.email": "Enter a valid email address.",
  "signin.validation.phone": "Enter a valid phone number.",
  "signin.validation.invalid": "Invalid value.",
  "signin.validation.invalidIdentifier": "The email or phone number is not registered.",
  "signin.validation.invalidOtp": "Invalid verification code.",
  "signin.validation.tooManyRequests": "Too many attempts. Please try again later.",
  "signin.noAccount": "Don't have an account?",
  "signin.createAccount": "Create Account",
  "signup.title": "Create Account",
  "signup.tabs.email": "Email",
  "signup.tabs.phone": "Phone",
  "signup.label.firstName": "First Name",
  "signup.label.lastName": "Last Name",
  "signup.label.email": "Email address",
  "signup.label.phone": "Phone number",
  "signup.placeholder.firstName": "John",
  "signup.placeholder.lastName": "Doe",
  "signup.submit": "Create Account",
  "signup.subtitle": "Sign up with one-time password",
  "signup.signinPrompt": "Already have an account?",
  "signup.signinAction": "Sign in instead",
  "signup.otp.title": "Enter the 6-digit code",
  "signup.validation.required": "This field is required.",
  "signup.validation.email": "Enter a valid email address.",
  "signup.validation.phone": "Enter a valid phone number.",
  "signup.validation.invalid": "Invalid value.",
  "signup.validation.minLength": "Minimum 2 characters required.",
  "otp.timer": "Time remaining",
  "otp.submit": "Verify Code",
  "otp.notReceived": "Didn't receive the code?",
  "otp.resend": "Resend Code",
  "nameForm.title": "Let's know you better",
  "nameForm.enterName": "Personal Information",
  "nameForm.specifications": "Specifications",
  "nameForm.step.identity": "Identity",
  "nameForm.step.demographics": "Demographics",
  "nameForm.step.context": "Complete Profile",
  "nameForm.stepProgress": "Step {{current}} of {{total}}",
  "nameForm.previous": "Previous",
  "nameForm.next": "Continue",
  "nameForm.label.firstName": "First Name",
  "nameForm.label.lastName": "Last Name",
  "nameForm.label.country": "Country",
  "nameForm.label.age": "Age",
  "nameForm.label.birthdate": "Birth Date",
  "nameForm.label.gender": "Gender",
  "nameForm.label.maritalStatus": "Marital Status",
  "nameForm.label.hasChildren": "Children",
  "nameForm.label.mobile": "Mobile Number",
  "nameForm.label.email": "Email",
  "nameForm.label.nationalID": "National ID",
  "nameForm.gender.male": "Male",
  "nameForm.gender.female": "Female",
  "nameForm.gender.other": "Other",
  "nameForm.marital.single": "Single",
  "nameForm.marital.married": "Married",
  "nameForm.marital.divorced": "Divorced",
  "nameForm.children.no": "No",
  "nameForm.children.yes": "Yes",
  "nameForm.placeholder.firstName": "John",
  "nameForm.placeholder.lastName": "Doe",
  "nameForm.submit": "Complete Registration",
  "nameForm.validation.required": "This field is required.",
  "nameForm.validation.minLength": "Minimum 2 characters required.",
  "nameForm.validation.termsRequired": "You must accept the terms and conditions.",
  "nameForm.termsPrefix": "I accept the",
  "nameForm.termsLink": "Terms and Conditions",
  "nameForm.termsTitle": "Terms and Conditions",
  "nameForm.termsWelcome": "Welcome to Chaman Patient Portal",
  "nameForm.termsIntro": "By using our services, you agree to these terms. Please read them carefully.",
  "nameForm.termsAcceptanceTitle": "1. Acceptance of Terms",
  "nameForm.termsAcceptance": "By accessing and using Chaman Clinic services, you accept and agree to be bound by the terms and provision of this agreement.",
  "nameForm.termsUseTitle": "2. Use of Services",
  "nameForm.termsUse": "Our services are intended for healthcare purposes. You agree to use the platform responsibly and provide accurate information. Misuse of services may result in account termination.",
  "nameForm.termsPrivacyTitle": "3. Privacy and Data Protection",
  "nameForm.termsPrivacy": "We are committed to protecting your personal and medical information. Your data will be handled in accordance with applicable privacy laws and our Privacy Policy.",
  "nameForm.termsAccountTitle": "4. Account Responsibilities",
  "nameForm.termsAccount": "You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. Notify us immediately of any unauthorized access.",
  "nameForm.termsModificationTitle": "5. Modifications to Terms",
  "nameForm.termsModification": "We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms.",
  "nameForm.termsContactTitle": "6. Contact Information",
  "nameForm.termsContact": "If you have any questions about these Terms and Conditions, please contact our support team.",
  "nameForm.termsClose": "Close",
  "toast.otpSent": "Verification code sent to your {{method}}",
  "toast.otpFailed": "Failed to send verification code. Please try again.",
  "toast.otpVerified": "Code verified successfully",
  "toast.otpInvalid": "Invalid verification code. Please try again.",
  "toast.invalidOtp": "Invalid verification code. Please try again.",
  "toast.loginSuccess": "Signed in successfully",
  "toast.completeProfile": "Please complete your profile to continue",
  "toast.completeRegistration": "Please complete your registration",
  "toast.registrationComplete": "Registration completed successfully",
  "toast.registrationFailed": "Registration failed. Please try again.",
  "toast.signupComplete": "Account created successfully",
  "toast.signinSuccess": "Signed in successfully",
  "errors.title": "Error",
  "errors.unknown": "An unexpected error occurred. Please try again.",
  "errors.networkError": "Unable to connect to the server. Please check your internet connection.",
  "errors.connectionTitle": "Connection Error",
  "errors.badRequest": "Invalid request. Please check your input and try again.",
  "errors.unauthorized": "Your session has expired. Please sign in again.",
  "errors.authTitle": "Authentication Required",
  "errors.forbidden": "You don't have permission to access this resource.",
  "errors.accessTitle": "Access Denied",
  "errors.notFound": "The requested resource was not found.",
  "errors.validationError": "Please correct the errors in the form.",
  "errors.tooManyRequests": "Too many requests. Please wait a moment and try again.",
  "errors.serverError": "Server error occurred. Our team has been notified.",
  "errors.serverTitle": "Server Error",
  "errors.serviceUnavailable": "Service is temporarily unavailable. Please try again later.",
  "selectDoctor.results": "results",
  "selectDoctor.loading": "Loading doctors...",
  "singleDoctor.loading": "Loading doctor details...",
  "selectDoctor.noResults": "No doctors found",
  "selectDoctor.doctorsFound": "Doctors Loaded",
  "selectDoctor.loadAgain": "Load Again",
  "filters.reset": "Reset All",
  "filters.apply": "Apply",
  "filters.showResults": "Show Results",
  "filters.specializations": "Specializations",
  "filters.professionals": "Professionals",
  "filters.therapy_types": "Therapy Types",
  "filters.therapist_treatments": "Therapist Treatments",
  "filters.genders": "Gender",
  "filters.disorders": "Disorders",
  "filters.bipolar": "Bipolar Mood Disorder",
  "filters.depression": "Depression",
  "filters.dissociative": "Dissociative Disorders",
  "filters.obsessive": "Obsessive Compulsive Disorder",
  "filters.eating": "Eating Disorders",
  "filters.gender": "Gender Dysphoria",
  "filters.personality": "Personality Disorder",
  "filters.somatic": "Somatic Symptom Disorder",
  "filters.trauma": "Trauma",
  "filters.addiction": "Addiction",
  "filters.languages": "Languages",
  "filters.dutch": "Dutch",
  "filters.english": "English",
  "filters.turkish": "Turkish",
  "filters.moroccan": "Moroccan Arabic",
  "filters.polish": "Polish",
  "filters.german": "German",
  "filters.french": "French",
  "filters.spanish": "Spanish",
  "filters.chinese": "Chinese/Mandarin",
  "filters.farsi": "Farsi",
  "filters.arabic": "Arabic",
  "filters.contact": "Contant Info",
  "filters.appointmentCost": "Appointment Cost",
  "search.instruction": "Search or filter to find relevant results. Current results are sorted by most recent.",
  "search.waitTime": "Wait Time",
  "search.distance": "Distance",
  "search.showMap": "Show map",
  "sort.relevance": "Relevance",
  "sort.rating": "Rating",
  "sort.availability": "Availability",
  "sort.experience": "Experience",
  "sort.nameAsc": "Name (A-Z)",
  "sort.nameDesc": "Name (Z-A)",
  "doctorCard.weeks": "weeks",
  "doctorCard.defaultRole": "Healthcare Provider",
  "doctor-appointment.peyment.failed": "Payment failed",
  "doctor-appointment.completeData": "Please complete the form.",
  "doctor-appointment.peyment.failed.description": "Please try again later.",
  "doctor-appointment.confirm": "Your appointment is confirmed",
  "doctor-appointment.confirm.description": "Your appointment has been booked and a confirmation message has been sent to you.",
  "doctor-appointment.cancel": "Your appointment is cancelled",
  "doctor-appointment.cancel.description": "Your appointment has been cancelled and a cancellation message has been sent to you.",
  "doctor-appointment.title": "Book Appointment",
  "doctor-appointment.add.new": "Add new member",
  "doctor-appointment.relate": "Relation",
  "relations.spouse": "Spouse",
  "relations.child": "Child",
  "doctor-appointment.relation.spouse": "Spouse",
  "doctor-appointment.relation.child": "Child",
  "doctor-appointment.next.session": "Your next session",
  "doctor-appointment.reminder": "We'll send you a reminder before your session.",
  "doctor-appointment.confirm.email": "A confirmation email has been sent to your registered email address.",
  "doctor-appointment.select-date": "Select Date and Time",
  "doctor-appointment.each-session": "Each Session",
  "doctor-appointment.appointment-type": "Appointment Type",
  "doctor-appointment.appointment-type.video-call": "Video Call",
  "doctor-appointment.appointment-type.in-person": "In-person",
  "doctor-appointment.appointment-type.online-meeting": "Online Meeting",
  "doctor-appointment.appointment-type.online": "Online",
  "doctor-appointment.appointment-type.visit-in-site": "In-person session at the clinic",
  "doctor-appointment.appointment-type.onsite": "In-person",
  "doctor-appointment.session-type": "Session type",
  "doctor-appointment.select-time": "Select time",
  "doctor-appointment.select-date-datepicker": "Select date",
  "doctor-appointment.select-service": "Service",
  "doctor-appointment.select-service-placeholder": "Select a service",
  "doctor-appointment.services-load-failed": "Could not load the available services. Please try again.",
  "doctor-appointment.locked-schedule-title": "Your reserved session",
  "doctor-appointment.payment-deadline": "Pay before",
  "doctor-appointment.continue": "Continue to select expert",
  "doctor-appointment.continue-to-pay": "Continue to payment",
  "doctor-appointment.owner": "Submit new case",
  "doctor-appointment.reservation-info": "You can reserve for yourself, or your family or your friends. Your information will be saved safely",
  "doctor-appointment.owner-information": "To create new case, select participant(s)",
  "doctor-appointment.participant-type.myself": "Myself",
  "doctor-appointment.participant-type.relation": "Relation",
  "doctor-appointment.participant-type.child": "My Child",
  "doctor-appointment.select-participants-first": "Please select participants first.",
  "doctor-appointment.participants-empty-error": "Please select at least one person other than yourself.",
  "doctor-appointment.submit": "Submit",
  "doctor-info.title": "Doctor's Info",
  "doctor-info.description": "Get to know your doctor",
  "select-doctor.title": "Select Doctor",
  "select-doctor.description": "Select your desired doctor",
  "select-doctor.filters.searchInput": "Search by name, number or email",
  "timepicker.available": "Available",
  "timepicker.selected": "Selected",
  "timepicker.inactive": "In Active",
  "timepicker.no-available-times": "No available times for today",
  "datepicker.selectDate": "Select Date",
  "patient.reservedDoctor": "Book with this doctor",
  "sidebar.collapse": "Collapse",
  "sidebar.back": "Back",
  "patient.sidebar.brandName": "Chaman",
  "patient.sidebar.home": "Home",
  "patient.sidebar.meetings": "Meetings",
  "patient.sidebar.transactions": "Transactions",
  "patient.sidebar.wallet": "Wallet",
  "patient.sidebar.treatment": "Treatment",
  "patient.sidebar.contactUs": "Contact us",
  "patient.contactUs.title": "Contact us",
  "patient.contactUs.message": "You can reach our support team by phone or WhatsApp.",
  "patient.contactUs.call": "Call",
  "patient.contactUs.whatsapp": "WhatsApp",
  "payment-method.payment": "Final check and Payment",
  "payment-method.appointment-details": "Appointment Details",
  "payment-method.date": "Date",
  "payment-method.appointment-time-start": "Start Time",
  "payment-method.appointment-time-end": "End Time",
  "payment-method.appointment-type": "Appointment Type",
  "payment-method.visit-cost": "Session Cost",
  "payment-method.sum": "Total cost to pay",
  "payment-method.confirm-and-pay": "Confirm & Pay",
  "payment-method.fast-pay": "Secure Payment",
  "payment-method.fast-confirm": "Instant Confirmation",
  "payment-method.free-cancellation": "Free Cancellation",
  "payment-method.payment-methods": "Payment Method",
  "payment-method.payment-info-notfound": "Payment Info Not Found",
  "payment-method.payment-info-is-not-complete": "Payment info is not complete!",
  "payment-method.select-payment-method": "Please select a payment method.",
  "payment-method.navigation-failed": "Could not open the participants page. Please try again.",
  "payment-method.ledger.title": "Payment summary",
  "payment-method.ledger.base-fee": "Appointment fee",
  "payment-method.ledger.base-fee-batch": "Appointment fee ({{count}} sessions)",
  "payment-method.ledger.discount": "Discount",
  "payment-method.wallet": "Wallet",
  "payment-method.ledger.wallet-balance": "Wallet balance",
  "payment-method.ledger.use-wallet": "Use wallet balance",
  "payment-method.ledger.no-wallet-balance": "No wallet balance available",
  "payment-method.ledger.net-payable": "Payable online",
  "payment-method.ledger.wallet-covered-success": "Paid from your wallet balance. Your appointment is confirmed.",
  "payment-method.ledger.wallet-covers-full": "Your wallet balance covers this appointment in full — no gateway needed. Just select \"Pay\".",
  "payment-method.methods-load-failed": "Could not load the payment methods. Please try again.",
  "payment-method.ledger.no-charge": "Nothing to pay for this appointment — no gateway needed. Select \"Pay\" to confirm.",
  "payment-method.ledger.no-charge-success": "Your appointment is confirmed.",
  "payment-method.hold-note": "When you select \"Pay\", this appointment is held for you for {{minutes}} minutes. If payment isn't completed in that time, it is released.",
  "payment-method.hold-note-batch": "When you select \"Pay\", these appointments are held for you for {{minutes}} minutes. If payment isn't completed in that time, they are released.",
  "expiry-banner.remaining": "Time left to complete payment",
  "expiry-banner.expired": "Your reserved time has expired and the slot has been released.",
  "expiry-banner.expired-blocked": "This reservation has expired. Please choose a new time to continue.",
  "payment-link.not-found-title": "Payment Link Not Found",
  "payment-link.expired-title": "Payment Link Expired",
  "payment-link.contact-clinic": "Please contact your clinic for a new payment link.",
  "payment-link.no-gateways-available": "Online payment is currently unavailable for this appointment. Please contact your clinic.",
  "payment-link.time-remaining": "Time remaining: {{hours}}h {{minutes}}m",
  "payment-link.expired-short": "This link has expired",
  "payment-link.select-gateway": "Please select a payment gateway.",
  "payment-link.result-load-failed": "We could not load your payment result",
  "payment-link.success-title": "Your appointment is confirmed",
  "payment-link.success-description": "Your appointment has been booked and a confirmation message has been sent to you.",
  "payment-link.failure-title": "Payment Failed",
  "payment-link.doctor": "Doctor",
  "payment-link.amount-paid": "Total Amount Paid",
  "payment-link.reference": "Payment Reference",
  "payment-link.try-again": "Try Again",
  "payment-link.failure-body": "Your payment was not completed. If any amount was deducted from your account, it will be returned to your bank account within 72 hours. If it has not been returned by then, please contact the clinic for support.",
  "payment-link.pending-title": "Payment Is Being Processed",
  "payment-link.pending-body": "We are still confirming your payment with the bank. This page will update automatically.",
  "payment-link.pending-unconfirmed": "Your payment has not been confirmed yet. Please do not pay again. If an amount was deducted and the payment is not confirmed, it will be returned to your bank account within 72 hours. If it has not been returned by then, please contact the clinic for support.",
  "payment-link.check-again": "Check Again",
  "payment-link.refund-due-title": "Payment Received, Appointment Not Booked",
  "payment-link.refund-due-body": "We received your payment, but this appointment had already expired or been cancelled, so it could not be booked. The clinic has been notified of this payment and will return it to you.",
  "payment-link.contact-clinic-questions": "If you have any questions, please contact the clinic.",
  "payment-link.gateway-failed-title": "We could not reach the payment gateway",
  "payment-link.gateway-failed": "Nothing was charged and your payment link is still valid. Please choose a payment method and try again.",
  "payment-link.reason-link-expired": "This payment link is no longer valid.",
  "payment-link.reason-appointment-expired": "The time held for this appointment has passed.",
  "payment-link.reason-appointment-cancelled": "This appointment has been cancelled.",
  "payment-link.reason-already-paid": "This appointment has already been paid for.",
  "payment-history.status": "Status",
  "payment-history.amount": "Amount",
  "payment-history.expires_at": "Expiration Date",
  "payment-history.created_at": "Transaction Date",
  "payment-history.transaction-history": "Transaction History",
  "payment-history.my-wallet": "My Wallet",
  "payment-history.balance": "Balance",
  "payment-history.money-return": "Refund",
  "payment-history.irtoman": "IRR",
  "payment-history.transaction_id": "Tracking Code",
  "payment-history.description": "Description",
  "payment-history.withdraw-funds": "Withdraw Funds",
  "payment-history.amount-min-error": "Minimum amount is 1,000 {{currency}}",
  "payment-history.card-number": "Card Number",
  "payment-history.card-invalid-error": "Card number must be exactly 16 digits.",
  "payment-history.account-holder": "Account Holder Name",
  "payment-history.wallet.loading-balance": "Loading Balance...",
  "global.loadMore": "Load more",
  "global.cancel": "Cancel",
  "global.submit": "Submit",
  "global.required": "This field is required.",
  "global.success": "Successful",
  "currency.IRR": "IRR",
  "currency.USD": "$",
  "patient-home.reserve-new-appointment": "New Case",
  "patient-home.reserve-appointment-for": "Reserve Appointment for",
  "patient-home.home": "Home",
  "patient-home.1th": "First",
  "patient-home.2th": "Second",
  "patient-home.3th": "Third",
  "patient-home.4th": "4th",
  "patient-home.5th": "5th",
  "patient-home.6th": "6th",
  "patient-home.7th": "7th",
  "patient-home.8th": "8th",
  "patient-home.9th": "9th",
  "patient-home.10th": "10th",
  "patient-home.11th": "11th",
  "patient-home.12th": "12th",
  "patient-home.13th": "13th",
  "patient-home.14th": "14th",
  "patient-home.15th": "15th",
  "patient-home.16th": "16th",
  "patient-home.17th": "17th",
  "patient-home.18th": "18th",
  "patient-home.19th": "19th",
  "patient-home.20th": "20th",
  "patient-home.session": "Session",
  "patient-home.support-request-title": "Send support request",
  "patient-home.support-request-send-to-whatsapp": "Send via WhatsApp",
  "patient-home.support-request-send-to-bale": "Send via Bale",
  "patient-home.support-request-send-to-sms": "Send via SMS",
  "patient-home.support-request-textarea-label": "Description",
  "patient-home.support-request-cancel": "Cancel",
  "patient-home.support-request-appointment-id": "Appointment ID",
  "patient-home.support-request-sms-toast-title": "Notice",
  "patient-home.support-request-sms-toast": "We copied your message to the clipboard. Please text us at {{phone}}.",
  "active-session.time": "Time",
  "active-session.date": "Date",
  "active-session.type": "Meeting Type",
  "active-session.visitor-name": "Visitor Name",
  "active-session.clinic-name": "Clinic",
  "active-session.clinic-label": "{{name}} Clinic",
  "active-session.notes": "Notes",
  "active-session.description": "Description",
  "active-session.appointment": "In-person",
  "active-session.online": "Online",
  "doctor-appointment.enter-meeting": "Enter Meeting",
  "doctor-appointment.support": "Support",
  "doctor-appointment.cancel-appointment": "Cancel Appointment",
  "doctor-appointment.proceed-to-payment": "Proceed to Payment",
  "doctor-appointment.change-time": "Reschedule Time",
  "error.general-error": "Error in fetch data",
  "doctor-appointment.cancel-appointment-description": "The amount paid will be returned to your credit within 24 hours.",
  "doctor-appointment.cancel-appointment-description-pending-payment": "This session has not been paid for yet. Cancelling it will free up this time.",
  "doctor-appointment.cancel-appointment-refound-amount": "Refund amount",
  "doctor-appointment.cancecl": "Cancel",
  "doctor-appointment.submit-and-cancel": "Submit and Cancel",
  "profile-settings.title": "Application Settings",
  "profile-settings.language": "Language",
  "profile-settings.select-language": "Select a language",
  "profile-settings.timezone": "Timezone",
  "profile-settings.select-timezone": "Search and select a timezone",
  "profile-settings.language.fa": "Persian",
  "profile-settings.language.en": "English",
  "profile-settings.language.de": "Deutch",
  "profile-settings.language.du": "Ducth",
  "appointment-card.status.pending": "Awaiting booking",
  "appointment-card.status.pending_payment": "Awaiting payment",
  "appointment-card.status.scheduled": "Confirmed",
  "appointment-card.status.completed": "Completed",
  "appointment-card.pending-description": "This session has not been booked yet. Choose a time to reserve it.",
  "appointment-card.progress": "{{done}} of {{total}} done",
  "appointment-card.sessions-strip": "Session progress: {{done}} of {{total}} done",
  "appointment-card.next": "Next",
  "appointment-card.and": "and",
  "appointment-card.selected": "Selected",
  "appointment-card.not-booked": "Not booked yet",
  "appointment-card.all-done": "All sessions in this plan are complete.",
  "appointment-card.pay": "Pay {{amount}} {{currency}}",
  "appointment-card.book": "Book this session",
  "appointment-card.show-sessions": "All sessions and options",
  "appointment-card.hide-sessions": "Hide sessions",
  "appointment-card.actions-for": "These actions apply to {{session}}.",
  "appointment-card.locked-hint": "Changing or cancelling this session is no longer possible here. Contact support if you need help.",
  "patient-home.empty-title": "Start your first case",
  "patient-home.empty-body": "Your sessions and payments will appear here once you book.",
  "patient-home.load-failed": "We could not load your sessions. Please try again.",
  "doctor-appointment.next-available-title": "No available times on this day",
  "doctor-appointment.next-available-description": "The closest bookable time is shown below.",
  "doctor-appointment.next-available-action": "Go to this time",
  "doctor-appointment.next-available-none": "There are no bookable times left in this month. Please check another month.",
  "doctor-appointment.booking-deadline-notice": "Booking for this day is closed: the clinic stops accepting next-day bookings after its daily cut-off time.",
  "doctor-appointment.past-times-notice": "Today's remaining times have already passed.",
  "treatment-plan-batch.title": "Book your treatment plan sessions",
  "treatment-plan-batch.instructions": "Pick a time for each remaining session. {{count}} session(s) still need a time.",
  "treatment-plan-batch.service": "Service",
  "treatment-plan-batch.pick-slots": "Available times",
  "treatment-plan-batch.selected-slots": "Selected times ({{count}})",
  "treatment-plan-batch.no-slots-selected": "Select at least one time before continuing.",
  "treatment-plan-batch.remove-slot": "Remove",
  "treatment-plan-batch.use-wallet-balance": "Use wallet balance",
  "treatment-plan-batch.gateway": "Payment method",
  "treatment-plan-batch.submit": "Reserve all selected times",
  "treatment-plan-batch.pinned-group-uses-locked-slot": "This session already has a fixed weekly time, so it is confirmed from your reserved slot.",
  "treatment-plan-batch.no-remaining-sessions": "All sessions in this treatment plan already have a time.",
  "treatment-plan-batch.session-limit-reached": "You've selected all the remaining sessions for this treatment plan.",
  "treatment-plan-batch.session-count-load-failed": "We could not load your remaining sessions. Please try again.",
  "booking.step.aria-label": "Booking steps",
  "booking.step.who": "Who it's for",
  "booking.step.expert": "Specialist",
  "booking.step.time": "Date and time",
  "booking.step.pay": "Payment",
  "booking.step.progress": "Step {{current}} of {{total}}",
  "booking.step.state.done": "done",
  "booking.step.state.current": "current step",
  "booking.step.state.upcoming": "not started",
  "booking.summary.title": "Your booking",
  "booking.summary.show": "Show booking details",
  "booking.summary.hide": "Hide booking details",
  "booking.summary.who": "For",
  "booking.summary.expert": "Specialist",
  "booking.summary.service": "Service",
  "booking.summary.type": "Session type",
  "booking.summary.date": "Date",
  "booking.summary.time": "Time",
  "booking.summary.fee": "Session fee",
  "booking.summary.not-chosen": "Not chosen yet",
  "booking.summary.nothing-yet": "Nothing chosen yet",
  "booking.owner.hint": "Choose who the session is for to continue",
  "booking.owner.people": "People",
  "booking.expert-card.view-profile": "View profile",
  "booking.expert-card.book": "Book",
  "booking.expert-card.next-available": "Next available",
  "booking.expert.about": "About",
  "booking.time.hint": "Choose a date and time to continue",
  "booking.time.session-type": "Session type",
  "booking.pay.hint": "Choose a payment method to continue.",
  "booking.pay.pay-amount": "Pay {{amount}} {{currency}}",
  "booking.confirm.details-title": "Session details",
  "booking.failed.retry-hint": "Your appointment was not paid. If it is still held for you, you can pay for it from your dashboard.",
  "booking.batch.progress": "{{selected}} of {{total}} sessions chosen"
}
